export default function Loading() {
  return (
    <div className="section section-center">
      <div className="loading"></div>
    </div>
  );
};
